import XAPPService from "app/Core/services/XAPPService";
import _ from "lodash";

export const GET_EMPRESAFORMAPAGAMENTOS = "{EMPRESAFORMAPAGAMENTO APP] GET FORMAPAGAMENTOS";
export const GET_EMPRESAFORMAPAGAMENTO = "{EMPRESAFORMAPAGAMENTO APP] GET FORMAPAGAMENTO";
export const GET_TEMPLATE = "{EMPRESAFORMAPAGAMENTO APP] GET TEMPLATE";

export const OPEN_NEW_EMPRESAFORMAPAGAMENTO_DIALOG = "{EMPRESAFORMAPAGAMENTO APP] OPEN NEW FORMAPAGAMENTO DIALOG";
export const CLOSE_NEW_EMPRESAFORMAPAGAMENTO_DIALOG = "{EMPRESAFORMAPAGAMENTO APP] CLOSE NEW FORMAPAGAMENTO DIALOG";
export const OPEN_EDIT_EMPRESAFORMAPAGAMENTO_DIALOG = "{EMPRESAFORMAPAGAMENTO APP] OPEN EDIT FORMAPAGAMENTO DIALOG";
export const CLOSE_EDIT_EMPRESAFORMAPAGAMENTO_DIALOG = "{EMPRESAFORMAPAGAMENTO APP] CLOSE EDIT FORMAPAGAMENTO DIALOG";

export const EMPRESAFORMAPAGAMENTO_REMOVE = "{EMPRESAFORMAPAGAMENTO APP] FORMAPAGAMENTO REMOVE";
export const ADD_EMPRESAFORMAPAGAMENTO = "{EMPRESAFORMAPAGAMENTO APP] ADD FORMAPAGAMENTO";

export const EMPRESAFORMAPAGAMENTO_WARNING = "{EMPRESAFORMAPAGAMENTO APP] FORMAPAGAMENTO WARNING";
export const EMPRESAFORMAPAGAMENTO_INFO = "{EMPRESAFORMAPAGAMENTO APP] FORMAPAGAMENTO INFO";
export const EMPRESAFORMAPAGAMENTO_ERROR = "{EMPRESAFORMAPAGAMENTO APP] FORMAPAGAMENTO ERROR";

const ListState =
    [
        "idpessoaformulario",
        "idpessoa",
        "nome",
        "tipo",
        "formulario",
        "statusregistro",
        "statusregistrodescricao",
        "usrins",
        "usrupt",
        "datainsdescricao",
        "datauptdescricao",
        "totalrows",
        "paginas",
    ];

const AddState =
    [
        "formulario",
        "idpessoa",
        "tipo",
    ];

const UpdateState =
    [
        "formulario"
    ];

export function get(_AIDPessoaFormulario, _AParams) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "pessoaformulario.idpessoaformulario", "Operador": "=", "Valor": _AIDPessoaFormulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "FormaPagamento", AActions, "spvwempresaformapagamento", ListState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAFORMAPAGAMENTO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAFORMAPAGAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function list(_AAction, _AParams, _AFilter = null, _APagina = 1, _ATarget = null, _ACallback = null) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var ATarget = !_.isNull(_ATarget) ? _ATarget : "spvwempresaformapagamento";

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = _AFilter.OR;
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "FormaPagamentos", AActions, ATarget, ListState, _AAction, AConditionsAND, AConditionsOR, _APagina);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) => {
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAFORMAPAGAMENTOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                        pagina: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].pagina : 1,
                    })
                ]);
                if (!_.isNull(_ACallback)) {
                    _ACallback();
                }
            }
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAFORMAPAGAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function openNewDialog() {
    return {
        type: OPEN_NEW_EMPRESAFORMAPAGAMENTO_DIALOG
    };
}

export function closeNewDialog() {
    return {
        type: CLOSE_NEW_EMPRESAFORMAPAGAMENTO_DIALOG
    };
}

export function openEditDialog(data) {
    return {
        type: OPEN_EDIT_EMPRESAFORMAPAGAMENTO_DIALOG,
        data
    };
}

export function closeEditDialog() {
    return {
        type: CLOSE_EDIT_EMPRESAFORMAPAGAMENTO_DIALOG
    };
}

export function save(_AValue, _AParams, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "INSERIR";

        if (_AValue.idpessoaformulario) {
            AAction = "ATUALIZAR";
            AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, UpdateState);
        }
        else {
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, AddState);
        }
        if (Number(_AValue.formulario?.default) === 1) {
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "", "FORMA-PAGAMENTO-PADRAO", _AValue, "", AConditionsAND, AConditionsOR);
        }

        XAPPService.XappCustomAction(AActions, _AParams, "spdoactionpessoaformulario", "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAFORMAPAGAMENTO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback();
                        }
                    });
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAFORMAPAGAMENTO_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback();
                        }
                    });
                }
            }

            ).catch(error => {
                return dispatch({
                    type: EMPRESAFORMAPAGAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function getTemplate() {
    return (dispatch) => {

        XAPPService.XappGetTemplateAction("pessoa", "138")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TEMPLATE,
                        payload: response,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAFORMAPAGAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function acaoRegistro(_AValue, _AParams, _AAction, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", _AAction, "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then(() =>
                Promise.all([
                    dispatch({
                        type: EMPRESAFORMAPAGAMENTO_REMOVE
                    })
                ]).then(() => {
                    if (!_.isNull(_ACallback)) {
                        _ACallback();
                    }
                })
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAFORMAPAGAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: GET_EMPRESAFORMAPAGAMENTOS,
        data: null,
        pagina: 1,
    };
}